import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BaseQuestionComponent } from '../base-question.component';

/**
 * Title question component.
 * Displays a title/heading in the form.
 * Uses Angular signals inherited from BaseQuestionComponent.
 */
@Component({
  selector: 'app-title-question',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './title-question.component.html',
  styleUrl: './title-question.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TitleQuestionComponent extends BaseQuestionComponent {
  onLabelChange(value: string): void {
    this.updateLabel(value);
  }

  onAdditionalInfoChange(value: string): void {
    this.updateAdditionalInfo(value);
  }
}

